import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

import { Organization as OrganizationLib } from "@secondcloset/fulfillment-utils";
import { Common } from "@secondcloset/types";
import { SelectLocation, IkeaVersionToggle } from "@secondcloset/web-components";

import { Space } from "antd";

import { useOrganizationContext } from "contextProviders/organization/OrganizationProvider";

import { useFacilityIndex } from "../../../../hooks/api/common/useFacilityIndex";
import useOrderCreateFlow from "../../../../hooks/reduxContainer/fulfillment/orderCreateFlow";
import Organization from "../../../../lib/organization";

type FacilityCode = Common.FacilityCode;

const SelectLocationStep: React.FC = () => {
  const { activeLocation, externalPlatformVersion, dispatchActiveLocation, dispatchSetExternalPlatformVersion } =
    useOrderCreateFlow();
  const { organization_id: orgID } = useParams<{ organization_id: string }>();
  const facilityIndex = useFacilityIndex();
  const isIkea = Organization.isIkeaOrgID(orgID);
  const isProduction = process.env.REACT_APP_ENV === "production";
  const organizationDetails = useOrganizationContext();

  const getDefaultFacilityCode = () => {
    const fallbackFacilityCode = OrganizationLib.DEFAULT_FALLBACK_FACILITY_CODE;
    const organization = organizationDetails.data;
    if (!organization) return fallbackFacilityCode;
    return OrganizationLib.getDefaultFulfilledFromFacility(organization) || fallbackFacilityCode;
  };

  useEffect(() => {
    if (isIkea) dispatchSetExternalPlatformVersion(2);
    dispatchActiveLocation(getDefaultFacilityCode());
    // eslint-disable-next-line
  }, []);

  return (
    <Space direction="vertical" align="center" style={{ width: "100%" }}>
      {isIkea && !isProduction ? (
        <IkeaVersionToggle
          selectedVersion={externalPlatformVersion}
          onVersionChange={dispatchSetExternalPlatformVersion}
        />
      ) : null}
      <SelectLocation
        defaultFacility={getDefaultFacilityCode() as FacilityCode}
        selectedFacility={activeLocation as FacilityCode}
        onFacilityChange={dispatchActiveLocation}
        facilitiesOption={facilityIndex.data ?? []}
      />
    </Space>
  );
};

export default SelectLocationStep;
